<template>
  <svg
    width="46"
    height="43"
    viewBox="0 0 46 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.2616 24.4839C27.2616 24.1974 27.2384 23.9094 27.1888 23.6276H23.214V25.2504H25.4902C25.3957 25.7737 25.0922 26.2367 24.6478 26.5309V27.5839H26.0058C26.8033 26.8499 27.2616 25.766 27.2616 24.4839Z"
      fill="#4285F4"
    />
    <path
      d="M23.2138 28.6011C24.3504 28.6011 25.3089 28.2279 26.0072 27.5837L24.6492 26.5308C24.2714 26.7879 23.7837 26.9334 23.2154 26.9334C22.116 26.9334 21.1839 26.1917 20.8494 25.1945H19.4481V26.28C20.1634 27.703 21.6205 28.6011 23.2138 28.6011V28.6011Z"
      fill="#34A853"
    />
    <path
      d="M20.8481 25.1947C20.6715 24.6713 20.6715 24.1046 20.8481 23.5812V22.4958H19.4483C18.8506 23.6865 18.8506 25.0894 19.4483 26.2802L20.8481 25.1947V25.1947Z"
      fill="#FBBC04"
    />
    <path
      d="M23.2138 21.8407C23.8146 21.8314 24.3953 22.0575 24.8304 22.4724L26.0335 21.2693C25.2717 20.5539 24.2606 20.1606 23.2138 20.173C21.6205 20.173 20.1634 21.0711 19.4481 22.4957L20.8478 23.5811C21.1808 22.5824 22.1145 21.8407 23.2138 21.8407V21.8407Z"
      fill="#EA4335"
    />
    <path
      d="M27 16.4727V12.4727M19 16.4727V12.4727M32 18.4727H14M30 30.4727H16C15.4696 30.4727 14.9609 30.262 14.5858 29.8869C14.2107 29.5119 14 29.0032 14 28.4727V16.4727C14 15.9423 14.2107 15.4336 14.5858 15.0585C14.9609 14.6834 15.4696 14.4727 16 14.4727H30C30.5304 14.4727 31.0391 14.6834 31.4142 15.0585C31.7893 15.4336 32 15.9423 32 16.4727V28.4727C32 29.0032 31.7893 29.5119 31.4142 29.8869C31.0391 30.262 30.5304 30.4727 30 30.4727Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="0.5"
      y="-0.5"
      width="45"
      height="41"
      rx="12.5"
      transform="matrix(-1 0 0 1 46 1.47272)"
      stroke="currentColor"
    />
  </svg>
</template>

<script setup lang="ts"></script>
